// Поставщик данных
// "База данных"
// Ссылки для меню

import { GoHome } from "react-icons/go";
import { GoBriefcase } from "react-icons/go";
import { GoBook } from "react-icons/go";
import { GoRocket } from "react-icons/go";
import { GoTools } from "react-icons/go";
import { GoGear } from "react-icons/go"
import HomePageContent from "./HomePageContent";
import ServicesPageContent from "./ServicesPageContent";
import ContactPageContent from "./ContactPageContent";

const uiTranslations = {
    eng: {
        header: "Nazarov's Projects",
        searchPlaceholder: "Search...",
        footer: "Made by Nazarov A.A. with React",
        settings: "Settings",
        language: "Language",
        save: "Save Options",
        projects: "Projects",
        pages: "Pages",
        home: "Home",
        search: "Search",
        madeWith: "Made with",
        by: "by"
    },
    rus: {
        header: "Проекты Назарова",
        searchPlaceholder: "Поиск...",
        footer: "Сделано Назаровым А.А. на React",
        settings: "Настройки",
        language: "Язык",
        save: "Сохранить настройки",
        projects: "Проекты",
        pages: "Страницы",
        home: "Главная",
        search: "Поиск",
        madeWith: "Сделано с",
        by: "автор"
    }
}
 
// Model.js - Updated with translations
// ... (previous imports remain the same)


// In Model.js, update the mainmenu object
const mainmenu = {
    eng: [
        { 
            'ob_id': 1,
            'link_route': '/',
            'link_caption': 'Home',
            'icon': <GoHome></GoHome>
        },
        { 
            'ob_id': 2,
            'link_route': '/projects',
            'link_caption': 'Projects',
            'icon': <GoBriefcase />
        },
        { 
            'ob_id': 3,
            'link_route': '/pages',
            'link_caption': 'Pages',
            'icon': <GoBook></GoBook>
        },
        { 
            'ob_id': 4,
            'link_route': '/settings',
            'link_caption': 'Settings',
            'icon': <GoGear></GoGear>
        },
    ],
    rus: [
        { 
            'ob_id': 1,
            'link_route': '/',
            'link_caption': 'Главная',
            'icon': <GoHome></GoHome>
        },
        { 
            'ob_id': 2,
            'link_route': '/projects',
            'link_caption': 'Проекты',
            'icon': <GoBriefcase />
        },
        { 
            'ob_id': 3,
            'link_route': '/pages',
            'link_caption': 'Страницы',
            'icon': <GoBook></GoBook>
        },
        { 
            'ob_id': 4,
            'link_route': '/settings',
            'link_caption': 'Настройки',
            'icon': <GoGear></GoGear>
        },
    ]
}

const pages = {
  eng: [ 
    { 
      'ob_id': 'index',
      'page_title': 'Home Page',
      'page_content': ( <>
        <ServicesPageContent></ServicesPageContent>   
      </> ) 
    },
    { 
      'ob_id': 'repos',
      'page_title': 'Repositories',
      'page_content': (
        <HomePageContent></HomePageContent>
      ),
    },
    { 
      'ob_id': 'contacts',
      'page_title': 'Contact Us',
      'page_content': (
        <>
          <ContactPageContent></ContactPageContent>
        </> 
      ),
    },
  ],
  rus: [ 
    { 
      'ob_id': 'index',
      'page_title': 'Главная страница',
      'page_content': ( <>
        <ServicesPageContent></ServicesPageContent>   
      </> ) 
    },
    { 
      'ob_id': 'repos',
      'page_title': 'Репозитории',
      'page_content': (
        <HomePageContent></HomePageContent>
      ),
    },
    { 
      'ob_id': 'contacts',
      'page_title': 'Обратная связь',
      'page_content': (
        <>
          <ContactPageContent></ContactPageContent>
        </> 
      ),
    },
  ]
};

// Проекты - Projects don't need translation structure since they're language independent
const projects = [
 
 { 
    'ob_id' : 'edt',
    'project_name'  : 'Электронные таблицы edt',
    'project_description' : 'Реализованы вычисления выражений и формул, открытие и сохранение файла',
    'repos' : [
        {
            'repoUrl' : 'https://github.com/ArtNazarov/edt',
            'repoTitle' : 'Github'
        },
        {
            'repoUrl' : 'https://gitflic.ru/project/artnazarov/edt',
            'repoTitle' : 'Gitflic reserve'
        },
        {
            'repoUrl' : 'https://gitverse.ru/ArtNazarov/edt',
            'repoTitle' : 'GitVerse reserve'
        },
        {
            'repoUrl' : 'https://codeberg.org/ArtNazarov/edt',
            'repoTitle' : 'CodeBerg reserve'
        }
    ],
},   
 { 
    'ob_id' : 'nzvbotlib',
    'project_name'  : 'Библиотека для Telegram бота',
    'project_description' : 'Реализованы ответы на команды, сохранение сообщений в базу, язык PHP',
    'repos' : [
        {
            'repoUrl' : 'https://github.com/ArtNazarov/NzvBotLib',
            'repoTitle' : 'Github'
        },
        {
            'repoUrl' : 'https://gitflic.ru/project/artnazarov/NzvBotLib',
            'repoTitle' : 'Gitflic reserve'
        },
        {
            'repoUrl' : 'https://gitverse.ru/ArtNazarov/nzvbotlib',
            'repoTitle' : 'GitVerse reserve'
        },
        {
            'repoUrl' : 'https://codeberg.org/ArtNazarov/NzvBotLib',
            'repoTitle' : 'CodeBerg reserve'
        }
    ],
},
{
    'ob_id' : 'edit_html_file',
    'project_name'  : 'Редактор HTML файлов edit_html_file',
    'project_description' : 'Фронтенд: vanilla js. Бэкенд: vanilla Python',
    'repos' : [
        {
            'repoUrl' : 'https://github.com/ArtNazarov/edit_html_file',
            'repoTitle' : 'Github'
        },
        {
            'repoUrl' : 'https://gitflic.ru/project/artnazarov/edit_html_file',
            'repoTitle' : 'Gitflic reserve'
        },
        {
            'repoUrl' : 'https://gitverse.ru/ArtNazarov/edit_html_file',
            'repoTitle' : 'GitVerse reserve'
        },
        {
            'repoUrl' : 'https://codeberg.org/ArtNazarov/edit_html_file',
            'repoTitle' : 'CodeBerg reserve'
        }
    ],
},
 {
    'ob_id' : 'nzt',
    'project_name'  : 'Библиотека nzt',
    'project_description' : 'Тестирование, TypeScript',
    'repos' : [
        {
            'repoUrl' : 'https://github.com/ArtNazarov/nzt',
            'repoTitle' : 'Github'
        },
        {
            'repoUrl' : 'https://www.npmjs.com/package/nzt-ts',
            'repoTitle' : 'NPM'
        },
        {
            'repoUrl' : 'https://gitflic.ru/project/artnazarov/nzt',
            'repoTitle' : 'Gitflic reserve'
        },
        {
            'repoUrl' : 'https://gitverse.ru/ArtNazarov/nzt',
            'repoTitle' : 'GitVerse reserve'
        },
        {
            'repoUrl' : 'https://codeberg.org/ArtNazarov/nzt',
            'repoTitle' : 'CodeBerg reserve'
        }
    ],
},
{ 
    'ob_id' : 'goferret',
    'project_name'  : 'Статический генератор goferret',
    'project_description' : 'Быстрое создание сайта по атрибутам и файловым шаблонам , язык Go',
    'repos' : [
        {
            'repoUrl' : 'https://github.com/ArtNazarov/goferret',
            'repoTitle' : 'Github'
        },
        {
            'repoUrl' : 'https://gitflic.ru/project/artnazarov/goferret',
            'repoTitle' : 'Gitflic reserve'
        },
        {
            'repoUrl' : 'https://gitverse.ru/ArtNazarov/goferret',
            'repoTitle' : 'GitVerse reserve'
        },
        {
            'repoUrl' : 'https://codeberg.org/ArtNazarov/goferret',
            'repoTitle' : 'CodeBerg reserve'
        }
    ],
},  
{
    'ob_id' : 'luassg',
    'project_name'  : 'luassg - генератор статических сайтов на языке Lua',
    'project_description' : 'Эксперимент',
    'repos' : [
        {
            'repoUrl' : 'https://github.com/ArtNazarov/luassg',
            'repoTitle' : 'Github'
        },
        {
            'repoUrl' : 'https://gitflic.ru/project/artnazarov/luassg',
            'repoTitle' : 'Gitflic reserve'
        },
        {
            'repoUrl' : 'https://gitverse.ru/ArtNazarov/luassg',
            'repoTitle' : 'GitVerse reserve'
        },
        {
            'repoUrl' : 'https://codeberg.org/ArtNazarov/luassg',
            'repoTitle' : 'CodeBerg'
        }
    ],
},
 { 
    'ob_id' : 'entity_xml_crud_app',
    'project_name'  : 'entity_xml_crud_app - GUI к luassg',
    'project_description' : 'Эксперимент, Python',
    'repos' : [
        {
            'repoUrl' : 'https://github.com/ArtNazarov/entity_xml_crud_app',
            'repoTitle' : 'Github'
        },
        {
            'repoUrl' : 'https://gitflic.ru/project/artnazarov/entity_xml_crud_app',
            'repoTitle' : 'Gitflic reserve'
        },
        {
            'repoUrl' : 'https://gitverse.ru/ArtNazarov/entity_xml_crud_app',
            'repoTitle' : 'GitVerse reserve'
        },
        {
            'repoUrl' : 'https://codeberg.org/ArtNazarov/entity_xml_crud_app',
            'repoTitle' : 'CodeBerg'
        }
    ],
}, 
{ 
    'ob_id' : 'nz_installer',
    'project_name'  : 'Библиотека nz_install',
    'project_description' : 'Для установки приложений в Linux, nodejs',
    'repos' : [
        {
            'repoUrl' : 'https://github.com/ArtNazarov/nz_installer',
            'repoTitle' : 'Github'
        },
        {
            'repoUrl' : 'https://www.npmjs.com/package/nz_installer',
            'repoTitle' : 'NPM'
        }
    ],
},
{ 
    'ob_id' : 'htmlbuilder',
    'project_name'  : 'HtmlBuilder',
    'project_description' : 'Генератор статических сайтов',
    'repos' : [
        {
            'repoUrl' : 'https://github.com/ArtNazarov/HtmlBuilder',
            'repoTitle' : 'Github'
        },
        {
            'repoUrl' : 'https://gitflic.ru/project/artnazarov/htmlbuilder',
            'repoTitle' : 'Gitflic reserve'
        },
        {
            'repoUrl' : 'https://gitverse.ru/ArtNazarov/HtmlBuilder',
            'repoTitle' : 'GitVerse reserve'
        },
        {
            'repoUrl' : 'https://codeberg.org/ArtNazarov/HtmlBuilder',
            'repoTitle' : 'CodeBerg'
        },
        {
            'repoUrl' : 'https://sourceforge.net/projects/sourceforge-mirror-htmlbuilder/',
            'repoTitle' : 'SourceForge'
        },
    ],
},
{ 
    'ob_id' : 'OneClickHostManager',
    'project_name'  : 'Программа One Click Host Manager',
    'project_description' : 'Для блокировки сайтов вроде нежелательной рекламы',
    'repos' : [
        {
            'repoUrl' : 'https://github.com/ArtNazarov/OneClickHostManager',
            'repoTitle' : 'Github'
        },
        {
            'repoUrl' : 'https://gitverse.ru/ArtNazarov/OneClickHostManager',
            'repoTitle' : 'GitVerse'
        },
        {
            'repoUrl' : 'https://gitflic.ru/project/artnazarov/oneclickhostmanager',
            'repoTitle' : 'GitFlic'
        },
        {
            'repoUrl' : 'https://codeberg.org/ArtNazarov/OneClickHostManager',
            'repoTitle' : 'CodeBerg'
        }
    ],
},
{ 
    'ob_id' : 'arch-post-installer',
    'project_name'  : 'Arch Post Installer',
    'project_description' : 'GUI для настройки Arch Linux',
    'repos' : [
        {
            'repoUrl' : 'https://github.com/ArtNazarov/arch-post-installer',
            'repoTitle' : 'Github'
        },
        {
            'repoUrl' : 'https://gitflic.ru/project/artnazarov/arch-post-installer',
            'repoTitle' : 'Gitflic reserve'
        },
        {
            'repoUrl' : 'https://gitverse.ru/ArtNazarov/arch-post-installer',
            'repoTitle' : 'GitVerse reserve'
        },
        {
            'repoUrl' : 'https://codeberg.org/ArtNazarov/arch-post-installer',
            'repoTitle' : 'CodeBerg'
        }
    ],
},
{ 
    'ob_id' : 'comment_tool',
    'project_name'  : 'comment_tool',
    'project_description' : 'Консольная утилита для комментирования каталогов',
    'repos' : [
        {
            'repoUrl' : 'https://github.com/ArtNazarov/comment_tool',
            'repoTitle' : 'Github'
        }
    ],
},
{ 
    'ob_id' : 'comment_tool_gui_qt',
    'project_name'  : 'comment_tool_gui_qt',
    'project_description' : 'Графический клиент для комментирования каталогов',
    'repos' : [
        {
            'repoUrl' : 'https://github.com/ArtNazarov/comment_tool_gui_qt',
            'repoTitle' : 'Github'
        }
    ],
},
{ 
    'ob_id' : 'clear_clipboard',
    'project_name'  : 'clear_clipboard',
    'project_description' : 'Очищает буфер обмена по интервалу',
    'repos' : [
        {
            'repoUrl' : 'https://github.com/ArtNazarov/clear_clipboard',
            'repoTitle' : 'Github'
        },
        {
            'repoUrl' : 'https://gitverse.ru/ArtNazarov/clear_clipboard',
            'repoTitle' : 'GitVerse'
        },
        {
            'repoUrl' : 'https://gitflic.ru/project/artnazarov/clear_clipboard',
            'repoTitle' : 'GitFlic'
        },
        {
        'repoUrl' : 'https://codeberg.org/ArtNazarov/clear_clipboard',
            'repoTitle' : 'Codeberg'
        },
    ],    
},
{ 
    'ob_id' : 'DesktopFileCleaner',
    'project_name'  : 'DesktopFileCleaner',
    'project_description' : 'Удаляет битые ярлыки в Linux',
    'repos' : [
        {
            'repoUrl' : 'https://github.com/ArtNazarov/DesktopFileCleaner',
            'repoTitle' : 'Github'
        },
        {
            'repoUrl' : 'https://gitverse.ru/ArtNazarov/DesktopFileCleaner',
            'repoTitle' : 'GitVerse'
        },
        {
            'repoUrl' : 'https://gitflic.ru/project/artnazarov/desktopfilecleaner',
            'repoTitle' : 'GitFlic'
        },
        {
        'repoUrl' : 'https://codeberg.org/ArtNazarov/DesktopFileCleaner',
            'repoTitle' : 'Codeberg'
        },
    ],    
},
{ 
    'ob_id' : 'censorit-chrome-ext',
    'project_name'  : 'CensorIt Chrome Ext',
    'project_description' : 'Расширение для цензуры для браузеров на основе Chrome по списку ключевых слов',
    'repos' : [
        {
            'repoUrl' : 'https://github.com/ArtNazarov/censorit-chrome-ext',
            'repoTitle' : 'Github'
        },
        {
            'repoUrl' : 'https://codeberg.org/ArtNazarov/censorit-chrome-ext',
            'repoTitle' : 'CodeBerg reserve'
        },
    ],
},
{ 
    'ob_id' : 'censorit-firefox-addon',
    'project_name'  : 'CensorIt Firefox Addon',
    'project_description' : 'Расширение для цензуры для браузеров на основе Firefox по списку ключевых слов',
    'repos' : [
        {
            'repoUrl' : 'https://github.com/ArtNazarov/censorit-firefox-addon',
            'repoTitle' : 'Github'
        },
        {
            'repoUrl' : 'https://codeberg.org/ArtNazarov/censorit-firefox-addon',
            'repoTitle' : 'CodeBerg reserve'
        },
        {
            'repoUrl' : 'https://gitverse.ru/ArtNazarov/censorit-firefox-addon',
            'repoTitle' : 'GitVerse reserve'
        },
        {
            'repoUrl' : 'https://gitflic.ru/project/artnazarov/censorit-firefox-addon',
            'repoTitle' : 'GitFlic reserve'
        }
    ],
},
 { 
    'ob_id' : 'elixir-ssg',
    'project_name'  : 'Статический генератор elixir-ssg',
    'project_description' : 'Быстрое создание сайта по атрибутам и файловым шаблонам , язык Elixir',
    'repos' : [
        {
            'repoUrl' : 'https://github.com/ArtNazarov/elixir-ssg',
            'repoTitle' : 'Github'
        },
        {
            'repoUrl' : 'https://gitflic.ru/project/artnazarov/elixir-ssg',
            'repoTitle' : 'Gitflic reserve'
        },
        {
            'repoUrl' : 'https://gitverse.ru/ArtNazarov/elixir-ssg',
            'repoTitle' : 'GitVerse reserve'
        },
        {
            'repoUrl' : 'https://codeberg.org/ArtNazarov/elixir-ssg',
            'repoTitle' : 'CodeBerg reserve'
        }
    ],
}
];

const blocks = {
  eng: [
    { 
      'ob_id': 'nodejs',
      'block_name': 'Node.js Development',
      'block_content': 'Node.js is a variant of the popular JavaScript language. Code written in Node.js can be executed on the server. Node.js features high speed, has a large library of components, and is supported by the developer community. The popularity of this platform grows every year. A website on Node.js will be an excellent solution if you need to handle many user requests.'
    },
    { 
      'ob_id': 'php',
      'block_name': 'PHP Development',
      'block_content': 'PHP is supported by most companies providing website publishing services. Popular content management systems like OpenCart or WordPress are written in PHP. A website on PHP is a good solution for starting on the internet.'
    },
    { 
      'ob_id': 'static',
      'block_name': 'Static Websites',
      'block_content': 'Static websites are created using HTML. For convenient site maintenance, modern static websites are published using static site generators, which act as databases and wrap data in templates for final presentation to the user. Static websites offer greater speed and higher security.'
    }
  ],
  rus: [
    { 
      'ob_id': 'nodejs',
      'block_name': 'Разработка на Node.js',
      'block_content': 'Nodejs - это разновидность популярного языка JavaScript. Код, написанный на NodeJs, можно выполнять на сервере. NodeJS отличается высокой скоростью работы, имеет большую библиотеку компонентов и поддерживается сообществом разработчиков. Популярность этой платформы растет с каждым годом. Сайт на NodeJS будет превосходным решением, если вам необходимо обрабатывать много запросов от пользователей.'
    },
    { 
      'ob_id': 'php',
      'block_name': 'Разработка на PHP',
      'block_content': 'PHP поддерживается большинством компаний, предоставляющих услуги по публикации сайтов в Интернете. Популярные системы управления сайтами, такие как OpenCart или Wordpress, написаны на PHP. Сайт на PHP - неплохое решение для старта в Интернете.'
    },
    { 
      'ob_id': 'static',
      'block_name': 'Статические сайты',
      'block_content': 'Статические сайты создаются на языке HTML. Для удобства обслуживания ресурса современный статический сайт публикуется с помощью генератора статических сайтов, который играет роль базы данных и оборачивает данные в шаблоны для конечного представления пользователю. Статический сайт отличается большей скоростью работы и более высоким уровнем безопасности.'
    }
  ]
};

// Updated getData function with language parameter
function getData(entity, lang = 'eng'){
    let result = null
    if ('mainmenu' === entity) {
        result = mainmenu[lang] || mainmenu.eng
    }
    if ("pages" === entity) {
        result = pages[lang] || pages.eng
    }
    if ("projects" === entity) {
        result = projects
    }
    if ("blocks" === entity) {
        result = blocks[lang] || blocks.eng
    }
    if ("ui" === entity) {
        result = uiTranslations[lang] || uiTranslations.eng
    }
    return result
}

// Updated getSingleEntity function with language parameter
function getSingleEntity(entity, ob_id, lang = 'eng') {
  const data = getData(entity, lang);
  if (!data) return null;
  const obj = data.find((elem) => {return elem.ob_id === ob_id});
  return obj;
}

export { getData, getSingleEntity, uiTranslations };
export default getData;